import { DocumentGeneralMultiTableEntity } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import { ExpandChildTable, GeneralTableFormComponent } from './generalTableResultPageDefinition';
import { OcrResultPageDefinition } from './types';

const generalMultiTableResultPageDefinition: OcrResultPageDefinition<DocumentGeneralMultiTableEntity> = {
  name: ocrTypeNameDefinitions.general_multi_table,
  tableColumns: [
    {
      title: '表の数',
      dataIndex: ['latest_revision', 'tables'],
      render: (value: string[][][]) => value.length,
    },
  ],
  tableExpandable: {
    expandedRowRender: ({ latest_revision: record }) =>
      record.tables.map((table, tableIndex) => <ExpandChildTable key={tableIndex} table={table} />),
  },
  formComponent: GeneralTableFormComponent,
};

export default generalMultiTableResultPageDefinition;
